// extracted by mini-css-extract-plugin
module.exports = {"subcategoryList":"_1MTac","subcategoryIcon":"nWHH-","link":"_3qILe","label":"_6-reT"};